class GigyaManager {

    constructor() {
        this.gigyaSdkReadyPromise = new Promise((resolve) => {
            if (!window.gigya) {
                if (!window.checkIntervalFette) {
                    window.checkIntervalFette = setInterval(function () {
                        if (window.gigya) {
                            clearInterval(window.checkIntervalFette);
                            resolve();
                        }
                    }, 500);
                }
            } else {
                return resolve();
            }
        });

        this.getLoggedUserPromise = this.getLoggedUser();
    }

    getLoggedUser() {
        return new Promise((resolve, reject) => {
            this.isGigyaSdkReady().then(() => {
                window.gigya.accounts.getAccountInfo({
                    callback: (data) => {
                        if (data.status == "OK") {
                            resolve(data);
                        } else {
                            reject(data);
                        }
                    },
                    include:"profile,data,preferences"
                });
            })
        });

    }

    getLoggedUserCached(){
        return this.getLoggedUserPromise;
    }

    getJWT() {
        return new Promise((resolve, reject) => {
            this.isGigyaSdkReady().then(() => {
                window.gigya.accounts.getJWT({
                    callback: (data) => {
                        if (data.status == "OK") {
                            resolve(data);
                        } else {
                            reject(data);
                        }
                    }
                });
            })
        });
    }


    isGigyaSdkReady() {
        return this.gigyaSdkReadyPromise;
    }

    addCH(chName){
        return new Promise((res, err)=>{
            var d = new Date();
            var m = d.getMonth() + 1;
            var month = (m + "").length > 1 ? m : "0" + m;
            var fullstr = d.getFullYear() + "-" + month + "-" + d.getDate();
            var data = {};
            data[chName] = fullstr;
            this.setAccountInfo({data:data, callback: (d) => {
                    if(d.status == "OK"){
                        res(true);
                    }else{
                        err(false);
                    }
                }});
        });
    }

    removeCH(chName){
        return new Promise((res, err)=>{
            var data = {};
            data[chName] = null;
            this.setAccountInfo({data:data, callback: (d) => {
                    if(d.status == "OK"){
                        res(true);
                    }else{
                        err(false);
                    }
                }});
        });
    }

    setAccountInfo(params){
            this.isGigyaSdkReady().then(() => {
                window.gigya.accounts.setAccountInfo(params);
            })
    }


    logout() {
        return new Promise((resolve) => {
            this.isGigyaSdkReady().then(() => {
                window.gigya.accounts.logout({
                    callback: () => {
                        resolve();
                    }
                });
            })
        });
    }
}

export default new GigyaManager();
